export default "__VITE_ASSET__bce1c7a8__"